"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactResponsiveModal = _interopRequireDefault(require("react-responsive-modal"));

var _reactI18next = require("react-i18next");

var _reactFinalForm = require("react-final-form");

var _ramda = require("ramda");

var _Checkbox = require("./Checkbox");

var _HtmlOpdForm = _interopRequireWildcard(require("./HtmlOpdForm"));

var _FormContext = require("../../context/FormContext");

var _attrs = require("../../utils/attrs");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = {
  "formWrapper": "index__formWrapper",
  "formBtn": "index__formBtn",
  "formBtnCancel": "index__formBtnCancel",
  "formLink": "index__formLink",
  "withoutOpd": "index__withoutOpd",
  "formLabel": "index__formLabel",
  "formLabelRequired": "index__formLabelRequired",
  "formLabelOptional": "index__formLabelOptional",
  "formInput": "index__formInput",
  "formTextarea": "index__formTextarea",
  "formSection": "index__formSection",
  "formSectionRow": "index__formSectionRow",
  "formSectionBtn": "index__formSectionBtn",
  "error": "index__error",
  "compositeError": "index__compositeError",
  "fileInput": "index__fileInput",
  "fileControls": "index__fileControls",
  "formDateSelect": "index__formDateSelect",
  "formMoneySelect": "index__formMoneySelect",
  "amountField": "index__amountField",
  "currencyField": "index__currencyField",
  "imagePreview": "index__imagePreview",
  "dangerBtn": "index__dangerBtn",
  "dangerBtnDisabled": "index__dangerBtnDisabled",
  "fileList": "index__fileList",
  "fileItem": "index__fileItem",
  "downloadButton": "index__downloadButton",
  "downloadButtonDisabled": "index__downloadButtonDisabled",
  "fileButtonGroup": "index__fileButtonGroup",
  "timeIndicator": "index__timeIndicator",
  "modalButtonGroup": "index__modalButtonGroup"
};

var getConstructorOpd = function getConstructorOpd(opdSettings, pdaLanguage, language) {
  var opdConstructor = (0, _ramda.pathOr)([], ['data', 'opdConstructor'], opdSettings);
  var text = (opdConstructor || []).reduce(function (res, cur) {
    switch (cur.type) {
      case 'question':
        return "".concat(res, "<input name=\"").concat(cur.question, "\" placeholder=\"").concat((0, _ramda.path)(['translations', pdaLanguage], cur) || (0, _ramda.path)(['translations', language], cur) || cur.placeholder || '', "\" type=\"text\" ").concat(cur.required ? 'required' : '', " /> ");

      case 'formated':
        return res + ((0, _ramda.path)(['translations', pdaLanguage], cur) || (0, _ramda.path)(['translations', language], cur) || cur.text || '');

      case 'checkbox':
        return "".concat(res, "<div>\n                    <input type=\"checkbox\" id=\"", "checkbox-".concat(cur.id), "\" ").concat(cur.required ? 'required="required"' : '', " />\n                    <label for=\"", "checkbox-".concat(cur.id), "\">").concat((0, _ramda.path)(['translations', pdaLanguage], cur) || (0, _ramda.path)(['translations', language], cur) || cur.label || '', "</label>\n                </div>");

      case 'opdCheckbox':
        return "".concat(res, "<div>\n                    <input type=\"checkbox\" id=\"").concat(cur.opdType, "\" name=\"").concat(cur.opdType, "\" data-separate-field=\"").concat(cur.opdType, "\" ").concat((0, _ramda.path)([cur.opdType, 'required'], opdSettings) ? 'required="required"' : '', " />\n                    <label for=\"").concat(cur.opdType, "\">").concat((0, _ramda.pathOr)('', ['translations', pdaLanguage], cur) || (0, _ramda.pathOr)('', ['translations', language], cur) || (0, _ramda.pathOr)('', [cur.opdType, 'translations', language], opdSettings) || (0, _ramda.pathOr)('', [cur.opdType, 'label'], opdSettings), "</label>\n                </div>");

      default:
        return res;
    }
  }, '');
  return "<div>\n        ".concat(text, "\n    </div>");
};

var PersonalDataAgreementComponent = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(PersonalDataAgreementComponent, _Component);

  var _super = _createSuper(PersonalDataAgreementComponent);

  function PersonalDataAgreementComponent() {
    var _this;

    (0, _classCallCheck2["default"])(this, PersonalDataAgreementComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      opened: false,
      openedHtml: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "open", function (event) {
      if (_this.props.opd) {
        event.preventDefault();

        _this.setState({
          opened: true
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "close", function () {
      return _this.setState({
        opened: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "closeHtml", function () {
      return _this.setState({
        openedHtml: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getLabel", function () {
      var _this$props = _this.props,
          t = _this$props.t,
          renderOpdLabel = _this$props.renderOpdLabel,
          opd = _this$props.opd,
          opdSettings = _this$props.opdSettings,
          pdaLanguage = _this$props.pdaLanguage,
          language = _this$props.language;
      var label = t('opdLabelCustom');
      var modalLinkProps = {
        className: opd ? styles.formLink : styles.withoutOpd,
        onClick: _this.open
      };
      var linkText = (0, _ramda.path)(['data', 'translations', 'labelLink', pdaLanguage], opdSettings) || (0, _ramda.pathOr)((0, _ramda.pathOr)(t('opdLink'), ['labelLink'], opdSettings), ['translations', 'labelLink', language], opdSettings);
      var link = (0, _ramda.path)(['data', 'translations', 'link', pdaLanguage], opdSettings) || (0, _ramda.pathOr)((0, _ramda.path)(['link'], opdSettings), ['translations', 'link', language], opdSettings);
      var opdText = (0, _ramda.path)(['data', 'translations', 'text', pdaLanguage], opdSettings) || (0, _ramda.pathOr)(opd, ['translations', 'text', language], opdSettings);
      var opdType = (0, _ramda.pathOr)('modal', ['linkType'], opdSettings);
      return /*#__PURE__*/_react["default"].createElement("span", null, renderOpdLabel ? renderOpdLabel(modalLinkProps) : label !== 'opdLabelCustom' ? label : /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, (0, _ramda.path)(['data', 'translations', 'labelStart', pdaLanguage], opdSettings) || (0, _ramda.pathOr)((0, _ramda.pathOr)(t('opdLabel'), ['labelStart'], opdSettings), ['translations', 'labelStart', language], opdSettings), ' ', opdType === 'modal' ? /*#__PURE__*/_react["default"].createElement("span", modalLinkProps, linkText) : /*#__PURE__*/_react["default"].createElement("a", {
        href: "//".concat(link),
        target: "_blank"
      }, linkText), ' ', (0, _ramda.path)(['data', 'translations', 'labelEnd', pdaLanguage], opdSettings) || (0, _ramda.pathOr)((0, _ramda.pathOr)('.', ['labelEnd'], opdSettings), ['translations', 'labelEnd', language], opdSettings)), /*#__PURE__*/_react["default"].createElement(_reactResponsiveModal["default"], {
        open: _this.state.opened,
        onClose: _this.close,
        classNames: {
          modal: 'pda-modal',
          closeButton: 'pda-modal-close-button'
        },
        center: true
      }, /*#__PURE__*/_react["default"].createElement("div", {
        dangerouslySetInnerHTML: {
          __html: opdText
        }
      })));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function () {
      var submitting = _this.props.meta.submitting;
      !submitting && _this.setState({
        openedHtml: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSubmitHtml", function (html, data) {
      _this.props.input.onChange(html ? _objectSpread({
        value: !!html,
        htmlContent: html
      }, data || {}) : null);

      _this.setState({
        openedHtml: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getOpdValues", function (formProps) {
      var _this$props2 = _this.props,
          opdSettings = _this$props2.opdSettings,
          getOpdValues = _this$props2.getOpdValues,
          fields = _this$props2.fields;

      if (getOpdValues) {
        return getOpdValues(formProps);
      }

      if ((0, _ramda.path)(['useConstructor'], opdSettings)) {
        return (0, _ramda.pick)((0, _ramda.filter)(function (field) {
          return (0, _ramda.find)(function (i) {
            return i.type === 'question' && i.question === field;
          }, (0, _ramda.pathOr)([], ['data', 'opdConstructor'], opdSettings));
        }, (0, _ramda.map)((0, _ramda.prop)('field'), fields)), formProps.values || {});
      }

      return {};
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isHtmlOpd", function () {
      var constructorOpd = (0, _ramda.path)(['useConstructor'], _this.props.opdSettings) ? getConstructorOpd(_this.props.opdSettings, _this.props.pdaLanguage, _this.props.language) : null;
      return !!(_this.props.htmlOpd || constructorOpd);
    });
    return _this;
  }

  (0, _createClass2["default"])(PersonalDataAgreementComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          opdSettings = _this$props3.opdSettings,
          pdaLanguage = _this$props3.pdaLanguage,
          language = _this$props3.language;
      var isHtmlOpd = this.isHtmlOpd();
      var constructorOpd = (0, _ramda.path)(['useConstructor'], opdSettings) ? getConstructorOpd(opdSettings, pdaLanguage, language) : null;
      return /*#__PURE__*/_react["default"].createElement(_FormContext.FormContext.Consumer, null, function (_ref) {
        var htmlAttrs = _ref.htmlAttrs;
        return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_Checkbox.Checkbox, (0, _extends2["default"])({
          id: 'opdCheckbox'
        }, _this2.props, {
          onValueChange: isHtmlOpd ? _this2.onChange : null,
          options: [{
            value: true,
            label: _this2.getLabel()
          }],
          htmlAttrs: (0, _attrs.getAttrs)('opdCheckbox', htmlAttrs)
        })), isHtmlOpd && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactFinalForm.FormSpy, {
          subscription: ['values']
        }, function (formProps) {
          return /*#__PURE__*/_react["default"].createElement(_HtmlOpdForm.HtmlOpdFormClear, {
            open: _this2.state.openedHtml,
            value: _this2.props.input.value,
            values: _this2.getOpdValues(formProps),
            onSubmitHtml: _this2.onSubmitHtml
          });
        }), /*#__PURE__*/_react["default"].createElement(_reactResponsiveModal["default"], {
          open: _this2.state.openedHtml,
          onClose: _this2.closeHtml,
          classNames: {
            modal: 'pda-modal',
            closeButton: 'pda-modal-close-button'
          },
          destroyOnClose: true,
          showCloseIcon: false,
          center: true
        }, /*#__PURE__*/_react["default"].createElement(_reactFinalForm.FormSpy, null, function (formProps) {
          return /*#__PURE__*/_react["default"].createElement(_HtmlOpdForm["default"], {
            onSubmit: _this2.onSubmitHtml,
            onClose: _this2.closeHtml,
            value: _this2.props.input.value,
            formProps: formProps,
            formFields: _this2.props.fields,
            getOpdValues: function getOpdValues() {
              return _this2.getOpdValues(formProps);
            },
            htmlAttrs: htmlAttrs,
            html: _this2.props.htmlOpd || constructorOpd,
            htmlOpdStyles: _this2.props.htmlOpdStyles,
            acceptBtn: (0, _ramda.path)(['data', 'translations', 'acceptButtonLabel', pdaLanguage], opdSettings) || (0, _ramda.pathOr)((0, _ramda.path)(['acceptButtonLabel'], opdSettings), ['translations', 'acceptButtonLabel', language], opdSettings)
          });
        }))));
      });
    }
  }]);
  return PersonalDataAgreementComponent;
}(_react.Component);

(0, _defineProperty2["default"])(PersonalDataAgreementComponent, "defaultProps", {
  opdSettings: {}
});
var PersonalDataAgreement = (0, _reactI18next.withTranslation)()(PersonalDataAgreementComponent);
var _default = PersonalDataAgreement;
exports["default"] = _default;